import React, { useMemo } from 'react';

import { orderBy } from 'lodash';
import { Controller, useFormContext } from 'react-hook-form';

import useUserHook from 'hooks/useUserHook';

import { useProjectTreeStore } from 'store/projectContract.store';

import { useQueryGetStoredTags } from 'api/queries/getStoredTags.query';

import { CustomizedFormErrorMessage, MyCustomSelect } from 'components/common';
import { FormProps } from 'components/widgets/RiskRegister/components/UploadRisksButton/components/UploadRisksModal/UploadRisksModal';
import classes from 'components/widgets/RiskRegister/components/UploadRisksButton/components/UploadRisksModal/UploadRisksModal.module.scss';

export const TagsInput = () => {
    const form = useFormContext<FormProps>();
    const { customerId } = useUserHook();
    const { project, contract } = useProjectTreeStore();
    const { data: tagsList } = useQueryGetStoredTags({
        enabled: true,
        customerId,
        projectId: project?.id,
        contractId: contract?.id,
    });

    const tagsOptions = useMemo<ISelectOption<number>[]>(
        () =>
            tagsList
                ? orderBy(
                      tagsList.map((item) => ({ label: item.name, value: item.tagId })),
                      [(item) => item.label.toLowerCase()],
                      ['asc'],
                  )
                : [],
        [tagsList],
    );
    return (
        <div className={classes.row}>
            <Controller
                render={({ field }) => (
                    <MyCustomSelect<ISelectOption<number>, true>
                        onChange={(value) =>
                            form.setValue(
                                'tags',
                                value.map((item) => item.label),
                            )
                        }
                        value={tagsOptions.filter((item) => field.value.includes(item.label))}
                        options={tagsOptions}
                        isMulti
                        isClearable={true}
                        placeholder={'Tag all risks...(optional)'}
                    />
                )}
                name="tags"
                control={form.control}
            />
            {form.formState.errors.tags && <CustomizedFormErrorMessage text={form.formState.errors.tags.message} />}
        </div>
    );
};
